import arabicContent from "assets/data/locales/sa.json";
import { directions } from "utility/config";

export const EnglishToArabicTransformer = (value, dir) => {
  return dir === directions.RTL ? arabicContent?.[value] || value : value;
};
